import type { RouteLocationNormalizedLoaded } from 'vue-router';
import IndicationHelper from './indication.helper';

export default class InternalNavigationHelper {
  static scrollToElement = (
    document: Document,
    elementId: string,
    block: ScrollLogicalPosition = 'center'
  ) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block });
    }
  };

  static handleActionPlanScroll = async (
    document: Document,
    route: RouteLocationNormalizedLoaded
  ) => {
    const { itemId: milestoneId } = route.params;
    const { taskId } = route.query;

    if (!milestoneId) return;

    const milestoneDiv = document.getElementById(milestoneId as string);
    if (!milestoneDiv) return;

    InternalNavigationHelper.scrollToElement(document, milestoneId as string);

    if (!taskId) {
      IndicationHelper.addBlinkingClass(milestoneId as string);
      return;
    }

    const taskDiv = document.getElementById(taskId as string);
    if (!taskDiv) {
      IndicationHelper.addBlinkingClass(milestoneId as string);
      return;
    }

    IndicationHelper.addBlinkingClass(taskId as string);
  };

  static handleFilesScroll = async (document: Document, route: RouteLocationNormalizedLoaded) => {
    const { fileId } = route.query;

    if (!fileId) return;

    const fileDiv = document.getElementById(fileId as string);
    if (!fileDiv) {
      setTimeout(() => {
        InternalNavigationHelper.handleFilesScroll(document, route);
      }, 500);
      return;
    }

    InternalNavigationHelper.scrollToElement(document, fileId as string);
    IndicationHelper.addBlinkingClass(fileId as string);
  };

  static handleChatMessageScroll = async (
    document: Document,
    route: RouteLocationNormalizedLoaded
  ) => {
    const { messageId } = route.query;

    if (!messageId) return;

    const messageDiv = document.getElementById(messageId as string);

    if (!messageDiv) {
      setTimeout(() => {
        InternalNavigationHelper.handleChatMessageScroll(document, route);
      }, 500);
      return;
    }

    if (!messageDiv) return;

    InternalNavigationHelper.scrollToElement(document, messageId as string);
    IndicationHelper.addBlinkingClass(messageId as string);
  };
}
